<template>
  <reveal ref="menu" :isOpen="open" pageWrapId="page-wrap" appId="app" width="260" @openMenu="handleOpenMenu" @closeMenu="handleCloseMenu">
    <span class="separator"></span>
    <router-link v-for="item in main" :key="item.id" :to="slugHelper(item.link_page_slug, 'path')" :target="item.open_in_new_tab === 'true' ? '_blank':'_self'" class="menu-main">
      <span :class="{'is-active': currentpath === slugHelper(item.link_page_slug, 'name')}"><span class="icon-conic"></span>{{ item.link_page.title }}</span>
    </router-link>
    <span class="separator"></span>
    <a v-for="item in sub" :key="item.id" :href="item.link_url" :target="item.open_in_new_tab === 'true' ? '_blank':'_self'" class="menu-sub">
      <span>{{ item.link_title }}</span>
    </a>
    <div class="menu-utility" width="260">
      <text-size-selector
        :isopen=true
        :haslabel=true
        class="is-align-left is-dark"
      >
      </text-size-selector>
    </div>
    <ul class="locale-changer">
      <li>{{ $t("languages") }}</li>
      <li @click="changeLocale('en')">
        <!-- <span class="flag-icon flag-icon-us"></span> -->
        <span :class="current_lang == 'en' ? 'active':''">English</span>
      </li>
      <li @click="changeLocale('ja')">
        <!-- <span class="flag-icon flag-icon-jp"></span> -->
        <span :class="current_lang == 'ja' ? 'active':''">日本語</span>
      </li>
      <li @click="changeLocale('zh')">
        <!-- <span class="flag-icon flag-icon-jp"></span> -->
        <span :class="current_lang == 'zh' ? 'active':''">中文</span>
      </li>
      <li @click="changeLocale('ko')">
        <!-- <span class="flag-icon flag-icon-jp"></span> -->
        <span :class="current_lang == 'ko' ? 'active':''">한국어</span>
      </li>
    </ul>
    <ul class="menu-sns" width="260">
      <li v-for="item in sns" :key="item.id">
        <a :href="item.link_url" :target="item.open_in_new_tab === 'true' ? '_blank':'_self'">
          <span :class="'icon-' + item.link_title.toLowerCase().trim()"></span>
        </a>
      </li>
      <li class="version">ver.{{version}}</li>
    </ul>
    <portal to="overray-dest">
      <div class="page-overray" ref="pageoverray" @click="handleCloseMenu"></div>
    </portal>
  </reveal>
</template>

<script>
import _ from 'lodash'
import { Reveal } from 'vue-burger-menu'
import TextSizeSelector from './TextSizeSelector.vue'

export default {
  name: 'NavMenu',
  props: {
    main: {
      type: Array,
      default: function() {
        return []
      }
    },
    sub: {
      type: Array,
      default: function() {
        return []
      }
    },
    sns: {
      type: Array,
      default: function() {
        return []
      }
    },
  },

  components: {
    Reveal,
    TextSizeSelector,
  },

  data () {
    return {
      bm: null,
      scrollTriggerPoint: 30,
      open: false,
      htmlEL: null,
      bodyEl: null,
      overray: null,
      active: false,
      currentpath: '/',
      current_lang: this.$root.$i18n.locale,
      version: process.env.VUE_APP_VERSION
    }
  },

  watch: {
    // watch the value of isLoading and once it's false hide the loader
    // isLoading(val) {
    //   if (val == false) {
    //     let self = this
    //     setTimeout(function(){
    //       self.showLoader = false
    //     }, 1)
    //   }
    // },
    $route (to, from){ // eslint-disable-line no-unused-vars
      // console.log('from', from)
      // console.log('to', to)

      // this.currentpath = to.path.replace(/^\/|\/$/g, '')
      this.currentpath = _(to.path).split('/').nth(1)

      // this.currentpath = to.name
      if(this.currentpath === ''){
        this.currentpath = 'home'
      }

      if (to.name !== from.name){
        this.open = false
      }
    },
    '$root.$i18n.locale'(locale) {
      this.current_lang = locale
    }
  },

  mounted(){
    window.addEventListener('scroll', _.throttle(this.handleScroll, 100), { passive: false })

    this.htmlEL = document.documentElement
    this.bodyEl = document.body
  },

  methods: {
    handleScroll: function(){
      const posTop = window.pageYOffset
      if(this.bm){
        if(posTop > this.scrollTriggerPoint){
          this.bm.classList.add('is-scrolled')
        } else {
          this.bm.classList.remove('is-scrolled')
        }
      } else {
        const menu_button = document.getElementsByClassName('bm-burger-button')
        this.bm = menu_button[0]
      }
    },
    handleOpenMenu: function(){
      this.open = true
      this.htmlEL.style.overflow = 'hidden'
      this.$refs.pageoverray.classList.add('is-active')
      // console.log('menu open')
    },
    handleCloseMenu: function(){
      this.open = false
      this.htmlEL.style.removeProperty('overflow')
      this.$refs.pageoverray.classList.remove('is-active')
      // console.log('menu close')
    },
    slugHelper: function (slug, type='name'){
      let route = {}

      if(slug.match(/^home-[^/]+/)) {
        route = {
          name: 'home',
          path: '/'
        }
      } else {
        route = {
          name: slug,
          path: '/' + slug + '/'
        }
      }
      // console.log('currentpath is ', this.currentpath)
      // console.log(type, route[type])
      return route[type]
    },
    changeLocale: function(lang){
      // const base_url = window.location.origin;
      // const url = base_url + '/' + lang + this.$route.path
      let ref = ''
      let kwd = ''
      if(this.$route.query && this.$route.query.ref && this.$route.query.ref != 'undefined'){
        ref = this.$route.query.ref
        if(this.$route.query.kwd && this.$route.query.kwd != 'undefined'){
          kwd = this.$route.query.kwd
        }
      }

      const url = '/' + lang + this.$route.path + (ref ? '?ref=' + this.$route.query.ref : '') + (kwd ? '&kwd=' + this.$route.query.kwd : '')

      this.$root.$i18n.locale = lang
      this.$nextTick(()=>{
        window.location.href = url
      })
    }
  }
}
</script>

<style lang="sass"></style>
